import actions from '../../../../../actions/fortnite-game/averagePlayTime.actions';
import {getAveragePlayTimeState} from '../../../../../selectors/fortnite-game/averagePlayTimeSelector';
import useWidgetData from '../hooks/useWidgetData';

import {WidgetState} from '../../../../../types';
import {WidgetDataParams} from '../types';

const useAveragePlayTimeData = (params: WidgetDataParams): WidgetState => {
    const widgetData: WidgetState = useWidgetData({
        widgetAction: actions.getAveragePlayTime,
        resetAction: actions.resetData,
        getWidgetState: getAveragePlayTimeState,
        ...params
    });

    return {
        ...widgetData
    };
};

export default useAveragePlayTimeData;
